<template>
    <div>
        <div class="row row-space-top">
            <div class="col-size-auto">
                <h2 class="subtitle">{{ formatBrand(table.brand) }}</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-size-auto">
                <p v-html="setTableTextByBrand(tableTexts, table.brand)"></p>
            </div>
        </div>
        <table v-if="table.carModels.length > 0" class="table-list">
            <thead class="sticky-thead">
                <tr>
                    <th></th>
                    <th>
                        <a class="table-sorting-cta" v-on:click="sortBy('modelName')" v-bind:class="sortDirectionCssClass('modelName')">
                            Model
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                    <th>
                        <a class="table-sorting-cta" v-on:click="sortBy('propellant')" v-bind:class="sortDirectionCssClass('propellant')">
                            Brændstof
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                    <th>
                        <a class="table-sorting-cta" v-on:click="sortBy('gear')" v-bind:class="sortDirectionCssClass('gear')">
                            Gear
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                    <th>
                        <a class="table-sorting-cta" v-on:click="sortBy('electricRange')" v-bind:class="sortDirectionCssClass('electricRange')">
                            Elektrisk Rækkevidde
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                    <th>
                        <a class="table-sorting-cta" v-on:click="sortBy('co2')" v-bind:class="sortDirectionCssClass('co2')">
                            CO2
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                    <th class="align-right">
                        <a class="table-sorting-cta" v-on:click="sortBy('taxBase')" v-bind:class="sortDirectionCssClass('taxBase')">
                            Vejl. Beskatning fra
                            <svg width="20" height="20" class="icon">
                                <use href="/ui/icons/custom-sprite.svg#feather-chevron-down"></use>
                            </svg>
                        </a>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(carModel, index) in table.carModels" v-bind:key="carModel.vin">
                    <td class="photo">
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink prerender"></a>
                        <img :src="carModel.imageUrl ? carModel.imageUrl : ('/ui/logos/' + table.brand + '.svg')"
                             alt="image"
                             loading="lazy"
                             @error="e => {
                                const fallback = '/ui/logos/' + table.brand + '.svg';
                                if (e.target.src !== fallback) e.target.src = fallback;
                              }" />
                    </td>
                    <td>
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink prerender"></a>
                        <span v-bind:class="setCssClassForLongString(carModel.modelName)">{{ carModel.modelName }}</span>
                    </td>
                    <td>
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink prerender"></a>
                        <span>{{ formatPropellant(carModel.propellant) }}</span>
                    </td>
                    <td>
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink prerender"></a>
                        <span>{{ carModel.gear }}</span>
                    </td>
                    <td>
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink prerender"></a>
                        <span>{{ formatElectricRange(carModel.electricRange) }}</span>
                    </td>
                    <td>
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink prerender"></a>
                        <span>{{ formatCo2(carModel.co2) }}</span>
                        <svg width="46" height="16" class="icon" v-if="carModel.propellant == 'diesel' || carModel.propellant == 'gasoline' || carModel.propellant == 'benzin' && carModel.energyClass">
                            <use v-bind:href="'/ui/icons/energy-arrows.svg#_' + carModel.energyClass"></use>
                        </svg>
                    </td>
                    <td class="align-right">
                        <a v-bind:href="setModelPageUrl(carModel)" class="rowlink prerender"></a>
                        {{ carModel.taxBaseInPriceFormat }} kr.
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="100" v-html="setTableTextByBrand(termTexts, table.brand)"></td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
    import _ from 'lodash';
    import formatMixin from '../mixins/formatter.js';

    export default {
        name: 'stocklist-model-overview-table',
        mixins: [formatMixin],
        props: {
            tableData: {
                type: Object,
                default: undefined
            },
            tableTexts: {
                type: Object,
                default: undefined
            },
            termTexts: {
                type: Object,
                default: undefined
            },
        },
        data() {
            return {
                sortKey: 'modelName',
                reverseOrder: false
            }
        },
        computed: {
            table: function () {
                if (this.$props.tableData) {
                    let brandTable = this.$props.tableData;
                    brandTable.carModels = _.orderBy(brandTable.carModels, this.$data.sortKey, this.$data.reverseOrder ? 'desc' : 'asc');

                    return brandTable;
                }

                return undefined;
            },
        },
        methods: {
            sortBy: function (sortKey) {
                this.reverseOrder = (this.sortKey == sortKey) ? !this.reverseOrder : true;
                this.sortKey = sortKey;
            },
            sortDirectionCssClass: function (sortKey) {
                let cssClass = '';

                if (this.sortKey === sortKey) {
                    cssClass += 'is-selected';
                }

                if (this.sortKey === sortKey && !this.reverseOrder) {
                    cssClass += ' is-pointing-up';
                }

                return cssClass;
            },
            setModelPageUrl: function (carModel) {
                if (carModel.modelDetailsPageUrl) {
                    return carModel.modelDetailsPageUrl;
                }

                return '';
            },
            setCssClassForLongString: function (string) {
                if (string.length > 20) {
                    return 'wrap-text';
                }

                return '';
            },
            formatCo2: function (value) {
                if (value === 0) {
                    return "-"
                }

                return `${value} g/km`;
            },
            formatElectricRange: function (value) {
                if (value === 0) {
                    return "-"
                }

                return `${value} km`;
            },
            formatPropellant: function (value) {
                if (value === "gasoline" || value === "benzin") {
                    return "Benzin";
                } else if (value === "electric" || value === "el") {
                    return "El";
                } else if (value === "diesel") {
                    return "Diesel";
                } else if (value === "hybrid") {
                    return "Hybrid";
                }

                return "unknown"
            },
            setTableTextByBrand: function (textObj, brand) {
                if (!textObj) return "";

                switch (brand.toLowerCase()) {
                    case "audi":
                        return textObj.audi;
                    case "seat":
                        return textObj.seatCupra;
                    case "skoda":
                        return textObj.skoda;
                    case "volkswagen":
                        return textObj.volkswagen;
                    case "porsche":
                        return textObj.porsche;
                    default:
                        break;
                }
            }
        }
    }
</script>